import React from 'react';
import { Button } from 'reactstrap';
// import { DeleteUnitConversion } from './DeleteUnitConversion';
import { FormUnitConversion } from './FormUnitConversion';
import { Dialog } from 'primereact/dialog';


export const ModalUnitConversion = (props) => {

    const { modal, closeDialog, loading, method, units, id_unit_from, id_unit_to, conversion_factor, handleInputChange, saveCreate, saveUpdate, saveDelete } = props;

    const footer = (
        <div className='mt-2' style={{ display: "flex", justifyContent: "flex-end" }}>


            <Button
                color="secondary"
                size="sm"
                disabled={loading}
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "progress-bar-animated progress-bar-striped" : ""}
            >
                {
                    loading
                        ? (
                            <>
                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                {
                                    method === "create"
                                        ? "Guardando..."
                                        : "Actualizando..."
                                }
                            </>
                        )
                        : (
                            method === "create"
                                ? "Guardar"
                                : "Actualizar"
                        )
                }
            </Button>

            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>

        </div>
    );

    return (
        <Dialog

            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-square-root f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {
                                    method === "create" ?
                                        "Creación de unidades"
                                        : (method === "update") ?
                                            "Actualización de unidad"
                                            : "Eliminar unidad"
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v2`}

            footer={footer}
        >
            {
                method === "create" ?
                    <FormUnitConversion button="Crear nueva unidad" {...{ loading, units, id_unit_from, id_unit_to, conversion_factor, handleInputChange, methodAction: saveCreate }} />
                    : (method === "update") ?
                        <FormUnitConversion button="Actualizar unidad" {...{ loading, units, id_unit_from, id_unit_to, conversion_factor, handleInputChange, methodAction: saveUpdate }} />
                        : null
            }
        </Dialog>
    )
}
